import styled, { css } from 'styled-components';

import Placeholder from '@assets/images/promotions/promo_placeholder.webp';

export const Wrapper = styled.div<{ $bg?: string | null }>`
	height: 229px;
	width: 100%;
	padding: 16px;
	border-radius: 12px;
	position: relative;
	overflow: hidden;

	background-image: url(${({ $bg }) => ($bg ? $bg : Placeholder)});
	background-position: right;
	background-repeat: no-repeat;
	background-size: cover;

	@media (max-width: 992px) {
		&:after {
			content: '';
			position: absolute;
			top: 0;
			right: 0;
			width: 100%;
			height: 100%;
			z-index: 10;
			background-color: rgba(0, 0, 0, 0.4);
		}
	}
`;

export const Content = styled.div`
	height: 100%;
	position: relative;
	z-index: 20;

	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

export const DateRow = styled.div`
	display: flex;
	gap: 15px;
	align-items: center;

	@media (max-width: 992px) {
		margin-bottom: 8px;
	}
`;

export const Chip = styled.div<{ $isActive: boolean }>`
	font-size: 14px;
	line-height: 19px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	padding: 6px 8px;
	border-radius: 100px;
	background-color: ${({ theme }) => theme.colors.transparent.light20};

	${({ $isActive }) =>
		$isActive &&
		css`
			background-color: ${({ theme }) => theme.colors.other.calendarBackgroundDarkGreen};
			color: ${({ theme }) => theme.colors.text.link};
		`}

	@media (max-width: 992px) {
		padding: 4px 6px;
		font-size: 12px;
		line-height: 16px;
	}
`;

export const TextContainer = styled.div`
	max-width: 404px;
`;
export const Title = styled.h2`
	max-height: 54px;
	font-size: 20px;
	line-height: 27px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};
	margin-bottom: 8px;

	overflow: hidden;
	text-overflow: ellipsis;

	@media (max-width: 992px) {
		font-size: 18px;
		line-height: 25px;
		margin-bottom: 8px;
	}
`;

export const ButtonWrapper = styled.div``;

export const Description = styled.p`
	max-height: 38px;
	font-size: 14px;
	line-height: 19px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};

	overflow: hidden;
	text-overflow: ellipsis;

	@media (max-width: 992px) {
		max-height: 57px;
		font-size: 14px;
		line-height: 19px;
		margin-bottom: 8px;
	}
`;
